import { queryOptions, useQuery } from '@tanstack/react-query';
import { deriveExchangeStatus, getExchangeStatus } from '@/services/api/exchange';

const REFETCH_INTERVAL_MS = 60_000;

export const EXCHANGE_STATUS_QUERY_KEY = ['exchange', 'status'] as const;

export const exchangeStatusQueryOptions = () =>
  queryOptions({
    queryKey: EXCHANGE_STATUS_QUERY_KEY,
    queryFn: getExchangeStatus,
    select: deriveExchangeStatus,
    refetchInterval: REFETCH_INTERVAL_MS,
  });

export const useExchangeStatus = () => useQuery(exchangeStatusQueryOptions());
